import Vue from "vue";
import VueRouter from "vue-router";
import Error404 from "@/errors/404";
import NoAuthorized from "@/errors/NoAuthorized";
import { store } from "@/store/store";
Vue.use(VueRouter);

export default new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/landing",
      name: "MainPage",
      component: () => import("@/components/TemplateNewScreen/CommonLanding"),
      beforeEnter(to, from, next) {
        if (store.state.userData.token && store.state.userData.loanAppId) {
          next();
        } else {
          next("/404");
        }
      },
    },
    {
      path: "/self-upload",
      name: "UploadPage",
      component: () =>
        import("@/components/TemplateNewScreen/CommonUpload.vue"),
      beforeEnter(to, from, next) {
        if (store.state.userData.token && store.state.userData.loanAppId) {
          try {
            next();
          } catch (e) {
            console.log("error from self upload screen");
            console.error(e);
          }
        } else {
          next("/404");
        }
      },
    },
    {
      path: "/summary",
      name: "SummaryPage",
      component: () => import("@/components/TemplateNewScreen/CommonLanding"),
      beforeEnter(to, from, next) {
        if (store.state.userData.token && store.state.userData.loanAppId) {
          next();
        } else {
          next("/login");
        }
      },
    },
    {
      path: "/upload",
      name: "CallFromNativePage",
      component: () =>
        import("@/components/TemplateNewScreen/CommonCallFromNative"),
      beforeEnter(to, from, next) {
        next();
      },
    },
    {
      path: "/document-group",
      name: "DocumentGroupPage",
      component: () =>
        import("@/components/TemplateNewScreen/CommonDocumentGroup"),
      beforeEnter(to, from, next) {
        if (store.state.userData.token && store.state.userData.loanAppId) {
          next();
        } else {
          next("/404");
        }
      },
    },
    {
      path: "/lst-account",
      name: "ListAccountPage",
      component: () =>
        import("@/components/TemplateNewScreen/CommonListAccount"),
      beforeEnter(to, from, next) {
        if (store.state.userData.token && store.state.userData.loanAppId) {
          next();
        } else {
          next("/404");
        }
      },
    },
    {
      path: "/d-statement",
      name: "DstatementPage",
      component: () =>
        import("@/components/TemplateNewScreen/CommonDStatement.vue"),
      beforeEnter(to, from, next) {
        if (store.state.userData.token && store.state.userData.loanAppId) {
          next();
        } else {
          next("/404");
        }
      },
    },
    {
      path: "/self-upload-other-banks",
      name: "UploadOtherBanksPage",
      component: () =>
        import("@/components/TemplateNewScreen/CommonUploadOtherBanks.vue"),
      beforeEnter(to, from, next) {
        if (store.state.userData.token && store.state.userData.loanAppId) {
          next();
        } else {
          next("/404");
        }
      },
    },
    {
      path: "/self-upload-other-bank",
      name: "UploadOtherBankPage",
      component: () =>
        import("@/components/TemplateNewScreen/CommonUploadOtherBank.vue"),
      beforeEnter(to, from, next) {
        if (store.state.userData.token && store.state.userData.loanAppId) {
          next();
        } else {
          next("/404");
        }
      },
    },
    //================================================
    //Common page
    //================================================
    {
      path: "/noAuthorized",
      name: "NoAuthorized",
      component: NoAuthorized,
    },
    {
      path: "/404",
      name: "404",
      component: Error404,
    },
  ],
});
